'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_IArray$package$IArray$() {
}
export { $c_s_IArray$package$IArray$ as $c_s_IArray$package$IArray$ };
$p = $c_s_IArray$package$IArray$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_IArray$package$IArray$;
/** @constructor */
function $h_s_IArray$package$IArray$() {
}
export { $h_s_IArray$package$IArray$ as $h_s_IArray$package$IArray$ };
$h_s_IArray$package$IArray$.prototype = $p;
$p.yg = (function(arr) {
  if ((arr === null)) {
    return null;
  } else if ((arr.a.length === 0)) {
    var this$2 = $j_java$002elang$002e$002dObject.$m_sci_ArraySeq$();
    $j_java$002elang$002e$002dObject.$m_s_reflect_ManifestFactory$ObjectManifest$();
    return $j_java$002elang$002e$002dObject.$p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$2);
  } else {
    return new $j_java$002elang$002e$002dObject.$c_sci_ArraySeq$ofRef(arr);
  }
});
var $d_s_IArray$package$IArray$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_IArray$package$IArray$, "scala.IArray$package$IArray$", ({
  rw: 1
}));
export { $d_s_IArray$package$IArray$ as $d_s_IArray$package$IArray$ };
var $n_s_IArray$package$IArray$;
function $m_s_IArray$package$IArray$() {
  if ((!$n_s_IArray$package$IArray$)) {
    $n_s_IArray$package$IArray$ = new $c_s_IArray$package$IArray$();
  }
  return $n_s_IArray$package$IArray$;
}
export { $m_s_IArray$package$IArray$ as $m_s_IArray$package$IArray$ };
